import React from "react"

import { Link } from "gatsby"

import PostLinkTransformer from "./parsers/PostLinkTransformer"
import { Trans } from "gatsby-plugin-react-i18next"

import withRecombee from "../contexts/withRecombee"

import { ChildSelector } from "../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "./_base/WPImage"

import { GatsbyImage, getImage } from "gatsby-plugin-image"

import * as resourcesSectionStyles from "../styles/ResourcesSection.module.css"

import moment from "moment"

const withFeaturedImage = posts => {
  return posts.map(p => {
    let featuredImage = null
    if (
      p.featuredImage &&
      p.featuredImage.node &&
      p.featuredImage.node.localFile
    )
      featuredImage = getImage(p.featuredImage.node.localFile)

    p.thumbnail = featuredImage

    return p
  })
}

const relevant = (posts, filters) => {
  if (!filters || filters.length === 0) return withFeaturedImage(posts)

  const lowerCaseFilters = filters.map(f => f.toLowerCase())

  return withFeaturedImage(
    posts.filter(p => {
      return (
        p.tags.nodes.filter(t =>
          lowerCaseFilters.includes(t.name.toLowerCase())
        ).length > 0
      )
    })
  )
}

const businessUnitStyle = post => {
  const tagsList = post.categories.nodes

  const tags = tagsList.map(t => t.name.toLowerCase())

  if (tags.includes(`consulting`))
    return resourcesSectionStyles.postItemConsulting
  if (tags.includes(`education`))
    return resourcesSectionStyles.postItemEducation
  if (tags.includes(`technical`)) return resourcesSectionStyles.postItemCode

  return ``
}

function ResourcesSection(props) {
  const [activeFilters, setActiveFilters] = React.useState([])

  const { content, posts, pageContext } = props
  
  const title = ChildSelector.select(
    content,
    `latest-post-heading`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )
 
  const handleReadPost = id => {
    if (props.recombee) {
      props.recombee.AddDetailView(`post-${id}`)
    }
  }

  return (
    <div className={`${props.className} ${resourcesSectionStyles.wrapper}`}>
      <div className={`row ${resourcesSectionStyles.heading}`}>
        <div className={`col-12 ${resourcesSectionStyles.titleWrapper}`}>
          <h1
            className={`${resourcesSectionStyles.title}`}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        </div>
        <div className={`col-2 ${resourcesSectionStyles.backgroundImage}`}>
          <WPImage
            holder={content}
            selector={`resources-media-assets`}
            mode={DISPLAY_MODE.normal}
          />
        </div>
      </div>

      <div className={`row ${resourcesSectionStyles.postList}`}>
        {(!posts || posts.length === 0) && <Trans>No posts found</Trans>}
        {posts &&
          relevant(posts, activeFilters).map(p => (
            <div
              key={p.id}
              className={`col-4 ${
                resourcesSectionStyles.postItemWrapper
              } ${businessUnitStyle(p)}`}
            >
              <div className={`${resourcesSectionStyles.postItemContent}`}>
                <p className={`${resourcesSectionStyles.date}`}>
                  {moment(p.date).format("MMM d, yyyy")}
                </p>
              {/*   <p className={`${resourcesSectionStyles.author}`}>
                  Published by {p.author && p.author.node && p.author.node.name}
                </p> */}
                <div className={`${resourcesSectionStyles.tagList}`}>
                  {p.tags &&
                    p.tags.nodes &&
                    p.tags.nodes.map((tag, indx) => (
                      <span
                        className={`${resourcesSectionStyles.tag}`}
                        key={indx}
                      >
                        {tag.name}
                      </span>
                    ))}
                </div>
                <p className={`${resourcesSectionStyles.title}`}>{p.title}</p>

                {p.thumbnail && (
                  <div className={`${resourcesSectionStyles.featuredImage}`}>
                    <GatsbyImage image={p.thumbnail} alt={p.title} />
                  </div>
                )}
                <p
                  className={`${resourcesSectionStyles.excerpt}`}
                  dangerouslySetInnerHTML={{
                    __html: p.excerpt,
                  }}
                ></p>
              </div>
              <div className={`row ${resourcesSectionStyles.postCtaWrapper}`}>
                <div className={`col-12 ${resourcesSectionStyles.postCta}`}>
                  <Link
                    className={businessUnitStyle(p)}
                    onClick={() => handleReadPost(p.databaseId)}
                    to={PostLinkTransformer(
                      p.uri,
                      pageContext.language,
                      pageContext.i18n.defaultLanguage,
                      pageContext.i18n.languages
                    )}
                  >
                    <Trans>Read full article</Trans>
                  </Link>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

export default withRecombee(ResourcesSection)
